import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAdminReset } from '../../api/auth.api';
import AuthLayout from '../../layouts/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

const ResetPassword = () => {
  const [form, setForm] = useState({ email: '', otp: '', newPassword: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await confirmAdminReset({ email: form.email, otp: form.otp, newPassword: form.newPassword });
      navigate('/admin/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  return (
    <AuthLayout>
      <div className="mb-7">
        <h2 className="text-2xl font-bold text-slate-900 leading-tight">Set New Password</h2>
        <p className="text-slate-500 text-sm mt-1">Enter the OTP from your email and choose a new password.</p>
      </div>

      {error && <Alert type="error" className="mb-5">{error}</Alert>}

      <form onSubmit={handleSubmit} className="space-y-1">
        <Input label="Email address" type="email" placeholder="admin@company.com" value={form.email} onChange={set('email')} required />
        <Input label="OTP Code" type="text" placeholder="6-digit code" value={form.otp} onChange={set('otp')} required maxLength={6} />
        <Input label="New Password" type="password" placeholder="Min. 6 characters" value={form.newPassword} onChange={set('newPassword')} required />
        <Input label="Confirm Password" type="password" placeholder="Repeat new password" value={form.confirm} onChange={set('confirm')} required />
        <div className="pt-2">
          <Button type="submit" fullWidth size="lg" loading={loading}>
            Reset Password
          </Button>
        </div>
      </form>

      <p className="text-center text-sm text-slate-400 mt-6">
        <a href="/admin/forgot-password" className="text-primary-600 hover:text-primary-700 font-medium hover:underline">
          Request new OTP
        </a>
      </p>
    </AuthLayout>
  );
};

export default ResetPassword;
